export default "__VITE_ASSET__lKoPPJmK__"